import React from "react";

const ColorsContext = React.createContext();

export default ColorsContext;
